angular.module('app').factory('SettingsExService', function (AppServiceApi, HttpHelper, // We will deprecate this
$http, $q) {
    let appSettings = null;
    let fac = {
        getSettings: getSettings,
        getCachedSettings: getCachedSettings,
        get: get
    };
    function get() {
        // NOTE: userDetails are memoized and returned as a promise
        let deferred = $q.defer();
        if (angular.isUndefined(appSettings)) {
            // console.log('userDetails from cache');
            deferred.resolve(appSettings);
            return deferred.promise;
        }
        return AppServiceApi.settings().then(function (response) {
            appSettings = response.data;
            return appSettings;
        });
    }
    // Get appSettings from http or cache
    function getCachedSettings() {
        let deferred = $q.defer();
        if (appSettings) {
            deferred.resolve(appSettings);
        }
        else {
            AppServiceApi.settings().then(function (response) {
                appSettings = response.data;
                deferred.resolve(appSettings);
            });
        }
        return deferred.promise;
    }
    function getSettings() {
        return HttpHelper.get('api/App/Settings');
    }
    return fac;
});
